module.exports = __webpack_public_path__ + "media/images/mobile/border_pink-aaec79b9e87ea78653858e5676260e8b.gif";